Vendd.Scripts.load(function () {

    var valEngine;
    var observable;
    var filedata;
    var $wrapper = $('.x-career-form'),
        wrapper;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.onSuccess = function (envelope) {
        wrapper.loading(false);

        var data = envelope.message.data;

        if (data) {
            $('.js-error', $wrapper).hide();
            $('.js-content', $wrapper).hide();

            $('.js-success', $wrapper).show();
            /* Track Career Form */
            if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                    fbq('trackCustom', 'CareerForm');
                }
            }
            /* END Track Career Form */
        } else {
            $('.js-error', $wrapper).show();
        };
    };

    wrapper.onFailure = function (envelope) {
        wrapper.loading(false);

        $('.js-error', $wrapper).show();
    };

    wrapper.submit = function () {
        wrapper.loading(true);
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Career.Messages.Submit(observable));
    };

    $wrapper.on('focusout', '.input-wrapper,.checkbox-wrapper, .textarea-wrapper, .upload-wrapper, .agreement-wrapper', function (e) {
        // Hide errors  
        $('.error-wrapper', $(this.parentElement)).children().hide();
    });

    $('.fileupload', $wrapper).on('click', function () {
        $('.uploaded-file', $wrapper).hide();
        $('.uploaded-file .text', $wrapper).text('');
    });

    $('.fileupload', $wrapper).fileupload({
        dataType: 'json',
        url: '/Engine/UploadCvFiles',
        autoUpload: false,
        replaceFileInput: false,
        fileInput: $("input:file"),
        multiple: false,
        singleFileUploads: true,
        done: function (e, data) {
            wrapper.submit();
        },
        fail: function(e, data) {
            $('.fileupload-invalid', $wrapper).show();
        },
        add: function (e, data) {
            $('.uploaded-file', $wrapper).show();
            $('.uploaded-file .text', $wrapper).text(data.files[0].name);
            $('.uploaded-file .js-delete-file', $wrapper).on('click', function (event) {
                event.preventDefault();
                $('.fileupload', $wrapper).val('');
                $('.uploaded-file', $wrapper).hide();
                $('.uploaded-file .text', $wrapper).empty();
                data.files.length = 0;
            });
            filedata = data;
        }
    });

    $(".js-submit-button").on('click', function () {
        wrapper.validate();
        if (filedata) {
            filedata.submit();
        }
    });

    wrapper.onValidationError = function (envelope) {

        var errors = envelope.message.data.errors;
        //Show only LatestError
        $.each(errors, function (index, error) {
            if (error.Property === 'FirstName') {
                $('.firstname-required', $wrapper).show();
            }
            if (error.Property === 'LastName') {
                $('.lastname-required', $wrapper).show();
            }
            if (error.Property === 'Email') {
                if (error.Rule === 'required') {
                    $('.email-required', $wrapper).show();
                }
                if (error.Rule === 'isEmail') {
                    $('.email-invalid', $wrapper).show();
                }
            }
            if (error.Property === 'Phone') {
                if (error.Rule === 'required') {
                    $('.phone-required', $wrapper).show();
                }
                if ( error.Rule === 'isNumeric') {
                    $('.phone-required', $wrapper).show();
                }
            }
            if (error.Property === 'JobTitle') {
                $('.jobtitle-required', $wrapper).show();
            }
            if (error.Property === 'Agreement') {
                  $('.agreement-required', $wrapper).show();
            }
            if (error.Property === 'CvFileUploaded') {
                $('.fileupload-required', $wrapper).show();
            }

        });

    };

        wrapper.validate= function () {

        var valOptions = {
            ValidationEngine: valEngine,
            valmodel: observable.model,
        };
        Vendd.DataValidation.ValidateModel(valOptions);       
        };

    if ($(".view-terms", $wrapper).length > 0) {
        $(".view-terms", $wrapper).fancybox();
    }

    /*this totally needs refactor*/
    var selectedJob = $('.js-job-title-select', $wrapper).val();
    var selectedJobId = $wrapper.data('jobid');

    observable = Vendd.Career.CreateApplicantInfo(selectedJob, selectedJobId);
    Vendd.Databinding.CreateControlDatabindings(wrapper, observable);
    valEngine = Vendd.Career.CreateDefaultJobInfoValidationModel(observable);
    Vendd.MessageBus.subscribe(Vendd.Career.Messages.SubmitSuccess, wrapper, wrapper.onSuccess);
    Vendd.MessageBus.subscribe(Vendd.Career.Messages.SubmitFailure, wrapper, wrapper.onFailure);
    Vendd.MessageBus.subscribe(Vendd.DataValidation.Messages.ValidationError, wrapper, wrapper.onValidationError);
});

